module.exports = __webpack_public_path__ + "img/peggy-bank.min.b50d54ad.svg";